"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PCE = function () {
  function PCE(params) {
    _classCallCheck(this, PCE);

    this.params = params;

    this.setPerformance();

    this.ceProfiles = {
      nedcbt: {
        combustion: {
          consumption: ["NEDCBT_CC", "NEDCBT_CU", "NEDCBT_CEU"],
          emissions: ["NEDCBT_CO2CC", "NEDCBT_CO2U", "NEDCBT_CO2EU"]
        },
        electric: {
          autonomy: ["NEDCBT_ACC"],
          consumption: ["NEDCBT_CE"]
        }
      },
      nedc: {
        combustion: {
          consumption: ["NEDC_CC", "NEDC_CU", "NEDC_CEU"],
          emissions: ["NEDC_CO2"]
        },
        electric: {
          autonomy: ["NEDC_ACC"],
          consumption: ["NEDC_CE"]
        }
      },
      wltp: {
        combustion: {
          consumption: ["WLTP_FB", "WLTP_FM", "WLTP_FA", "WLTP_FEA", "WLTP_CC"],
          emissions: ["WLTP_COCC", "NEDCBT_CO2CC"]
        },
        electric: {
          autonomy: ["WLTP_ACU", "WLTP_ACC"],
          consumption: ["WLTP_CE"]
        }
      }
    };

    this.elemNames = {
      NEDCBT_CU: {
        es: "Consumo urbano",
        pt: "Consumo urbano",
        units: "L/100 km"
      },
      NEDCBT_CC: {
        es: "Consumo combinado",
        pt: "Consumo combinado",
        units: "L/100 km"
      },
      NEDCBT_CEU: {
        es: "Consumo extra urbano",
        pt: "Consumo extra-urbano",
        units: "L/100 km"
      },
      NEDCBT_CO2U: {
        es: "Emisiones CO<sub>2</sub> ciclo urbano",
        pt: "Emissões CO<sub>2</sub> ciclo urbano",
        units: "g/km"
      },
      NEDCBT_CO2EU: {
        es: "Emisiones CO<sub>2</sub> ciclo extra urbano",
        pt: "Emissões CO<sub>2</sub> ciclo extra-urbano",
        units: "g/km"
      },
      NEDCBT_CO2CC: {
        es: "Emisiones CO<sub>2</sub> ciclo combinado",
        pt: "Emissões CO<sub>2</sub> ciclo combinado",
        units: "g/km"
      },
      NEDCBT_ACC: {
        es: "Autonomía batería ciclo combinado",
        pt: "Autonomía batería ciclo combinado",
        units: "km"
      },
      NEDCBT_CE: {
        es: "Consumo eléctrico",
        pt: "Consumo elétrico",
        units: "kWh"
      },
      NEDC_CU: {
        es: "Consumo urbano",
        pt: "Consumo urbano",
        units: "L/100 km"
      },
      NEDC_CC: {
        es: "Consumo combinado",
        pt: "Consumo combinado",
        units: "L/100 km"
      },
      NEDC_CEU: {
        es: "Consumo extra urbano",
        pt: "Consumo extra-urbano",
        units: "L/100 km"
      },
      NEDC_CO2: {
        es: "Emisiones CO<sub>2</sub>",
        pt: "Emissões CO<sub>2</sub>",
        units: "g/km"
      },
      NEDC_ACC: {
        es: "Autonomía batería ciclo combinado",
        pt: "Autonomia bateria ciclo combinado",
        units: "km"
      },
      NEDC_CE: {
        es: "Consumo eléctrico",
        pt: "Consumo elétrico",
        units: "kWh"
      },
      WLTP_FB: {
        es: "Consumo ciclo bajo",
        pt: "Consumo ciclo baixo",
        units: "L/100 km"
      },
      WLTP_FM: {
        es: "Consumo ciclo medio",
        pt: "Consumo ciclo médio",
        units: "L/100 km"
      },
      WLTP_FA: {
        es: "Consumo ciclo alto",
        pt: "Consumo ciclo alto",
        units: "L/100 km"
      },
      WLTP_FEA: {
        es: "Consumo ciclo extra alto",
        pt: "Consumo ciclo extra-alto",
        units: "L/100 km"
      },
      WLTP_CC: {
        es: "Consumo ciclo mixto",
        pt: "Consumo ciclo misto",
        units: "L/100 km"
      },
      WLTP_CO2B: {
        es: "",
        pt: "",
        units: ""
      },
      WLTP_CO2M: {
        es: "",
        pt: "",
        units: ""
      },
      WLTP_CO2A: {
        es: "",
        pt: "",
        units: ""
      },
      WLTP_CO2EA: {
        es: "",
        pt: "",
        units: ""
      },
      WLTP_COCC: {
        es: "Emisiones CO<sub>2</sub> fase combinada",
        pt: "Emissões CO<sub>2</sub> fase combinada",
        units: "g/km"
      },
      WLTP_ACU: {
        es: "Autonomía ciclo urbano",
        pt: "Autonomia ciclo urbano",
        units: "km"
      },
      WLTP_ACC: {
        es: "Autonomía ciclo combinado",
        pt: "Autonomia ciclo combinado",
        units: "km"
      },
      WLTP_CE: {
        es: "Consumo eléctrico",
        pt: "Consumo elétrico",
        units: "kWh"
      }
    };

    this.simpleLegals = {
      old: {
        es: "Consumo homologado de acuerdo con la normativa europea. El consumo de combustible y las emisiones de CO<sub>2</sub> no sólo dependen del rendimiento del vehículo; influyen también el comportamiento al volante y otros factores no técnicos.",
        pt: "Consumo homologado de acordo com a normativa europeia. O consumo de combustível e as emissões de CO2 não dependem apenas da performance do veículo, influencia também o comportamento ao volante e outros fatores não técnicos."
      },
      new: {
        es: {
          combustion: 'Consumo y emisiones homologados de conformidad con la normativa europea aplicable. Como consecuencia de la introducción del nuevo procedimiento de prueba armonizado a nivel mundial para vehículos ligeros (WLTP) los datos técnicos mostrados podrían ser actualizados antes de la matriculación del vehículo e influir en los tipos impositivos que resulten de aplicación. El equipamiento opcional y accesorios junto con otros factores no técnicos pueden afectar el consumo y las emisiones. Las motorizaciones mostradas pueden estar sujetas a restricciones de disponibilidad debido a cambios en la gama de motorizaciones Nissan. Consulta disponibilidad y fecha de entrega con tu Concesionario Nissan. Para más información sobre los valores oficiales de consumo y autonomía consulta <a href="https://www.nissan.es/wltp.html" target="_blank">https://www.nissan.es/wltp.html</a>.',
          electric: 'Consumo y autonomía homologados de conformidad con la normativa europea aplicable. El equipamiento opcional y accesorios junto con otros factores no técnicos pueden afectar el consumo y la autonomía. Las motorizaciones mostradas pueden estar sujetas a restricciones de disponibilidad debido a cambios en la gama de motorizaciones Nissan. Consulta disponibilidad y fecha de entrega con tu Concesionario Nissan. Para más información sobre los valores oficiales de consumo y autonomía consulta <a href="https://www.nissan.es/wltp.html" target="_blank">https://www.nissan.es/wltp.html</a>.'
        },
        pt: {
          combustion: 'Consumo e emissões homologadas de acordo com os regulamentos europeus aplicáveis. Como resultado da introdução do novo procedimento de teste harmonizado mundial para veículos ligeiros (WLTP), os dados técnicos mostrados podem ser atualizados antes do registro do veículo e influenciar as taxas de imposto que sejam aplicáveis. O equipamento opcional e acessórios, juntamente com outros fatores não técnicos, podem afetar o consumo e as emissões. As motorizações mostradas podem estar sujeitas às restrições de disponibilidade devido a alterações na gama de motores Nissan. Verifique a disponibilidade e a data de entrega com o seu Concessionário Nissan. Para mais informações sobre os valores oficiais de consumo e emissão, consulte <a href="https://www.nissan.pt/wltp.html" target="_blank">https://www.nissan.pt/wltp.html</a>.',
          electric: 'Consumo e autonomia homologados de acordo com os regulamentos europeus aplicáveis. O equipamento opcional e acessórios, juntamente com outros fatores não técnicos, podem afetar o consumo e a autonomia. As motorizações mostradas podem estar sujeitas às restrições de disponibilidade devido a alterações na gama de motores Nissan. Verifique a disponibilidade e a data de entrega com o seu Concessionário Nissan. Para mais informações sobre os valores oficiais de consumo e autonomia, consulte <a href="https://www.nissan.pt/wltp.html" target="_blank">https://www.nissan.pt/wltp.html</a>.'
        }
      }
    };

    this.setConsumAndEmiss();
  }

  _createClass(PCE, [{
    key: "setPerformance",
    value: function setPerformance() {
      var performance = this.params.performance;
      var finalPower = !this.params.isElectric ? performance.electricPower + " (" + performance.power + " CV)" : "" + performance.electricPower;
      this.params.performance.finalPower = finalPower;
      for (var i in performance) {
        var $container = $(".js-" + i + "-block");

        var $value = $(".js-" + i);
        if (typeof performance[i] === "undefined") {} else {
          if (performance[i].trim() !== "") {
            if (!this.params.isElectric) {
              $container.removeClass("hidden");
            } else if (i !== "cc") {
              $container.removeClass("hidden");
            }
            $value.text(performance[i]);
          }
        }
      }
    }

    // Consumptions & Emissions

  }, {
    key: "setConsumAndEmiss",
    value: function setConsumAndEmiss() {
      var type = "combustion";
      var homologation = "wltp";
      var blockSelector = ".js-wltp-combustion";

      var legalSimple = void 0;
      var response = function response(data) {
        console.log("OK data", data);
      };

      if (this.params.consumptEmissions.homologacion === "Eléctrico") {
        homologation = "wltp";
        type = "electric";
        blockSelector = ".js-wltp-electric";
      }

      if (this.params.consumptEmissions.homologacion === "Euro6B o anterior") {
        homologation = "nedc";
        type = "combustion";
        blockSelector = ".js-nedc-combustion";
      }
      this.setLegalSimple(type);
      this.displayData(blockSelector, homologation, type);
    }
  }, {
    key: "displayData",
    value: function displayData(blockSelector, homologation, type) {
      var a = void 0,
          b = void 0;
      switch (type) {
        case "combustion":
          a = this.ceProfiles[homologation][type].consumption;
          b = this.ceProfiles[homologation][type].emissions;
          break;
        case "electric":
          a = this.ceProfiles[homologation][type].autonomy;
          b = this.ceProfiles[homologation][type].consumption;
          break;
      }

      // this.setLegal(a, b)
      $(blockSelector).removeClass("hidden");
      for (var i = 0; i < a.length; i++) {
        $(".js-" + a[i]).text(this.params.consumptEmissions[a[i]]);
      }
      for (var _i = 0; _i < b.length; _i++) {
        $(".js-" + b[_i]).text(this.params.consumptEmissions[b[_i]]);
      }
    }
  }, {
    key: "setLegalSimple",
    value: function setLegalSimple(type) {
      this.legalSimple = this.simpleLegals["new"]["pt"][type];
      var model = this.params.model;
      // Si se trata de alguno de estos modelos se usa el legal antiguo
      if (model.toLowerCase().indexOf("navara") > -1 || model.toLowerCase().indexOf("nt400") > -1 || model.toLowerCase().indexOf("nv300") > -1 || model.toLowerCase().indexOf("nv400") > -1 || model.toLowerCase().indexOf("xtrail") > -1) {
        this.legalSimple = this.simpleLegals["old"]["pt"];
      }
      // Los comerciales que no sean combi, ni sean el Navara no llevan legal de Emisiones
      if (this.params.isCommercial === "true" && this.params.performance.body.toLowerCase() !== "combi" && model.toLowerCase().indexOf("navara") === -1) {
        this.legalSimple = "";
      }
    }
  }]);

  return PCE;
}();